import { render, staticRenderFns } from "./seatManage.vue?vue&type=template&id=6805e033&scoped=true"
import script from "./seatManage.vue?vue&type=script&lang=js"
export * from "./seatManage.vue?vue&type=script&lang=js"
import style0 from "./seatManage.vue?vue&type=style&index=0&id=6805e033&lang=scss&scoped=true"
import style1 from "./seatManage.vue?vue&type=style&index=1&id=6805e033&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805e033",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6805e033')) {
      api.createRecord('6805e033', component.options)
    } else {
      api.reload('6805e033', component.options)
    }
    module.hot.accept("./seatManage.vue?vue&type=template&id=6805e033&scoped=true", function () {
      api.rerender('6805e033', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/call/page/seatManage.vue"
export default component.exports